import React from "react";
import { getCurrentLanguage } from "../../../../utils/software";
import { getCurrentErrorsVersion, setCurrentErrorsOptions,getCurrentErrorsOptions } from "../../../../utils/software";
class SubtitleOptions extends React.Component {
    constructor(props) {
        super(props);
        this.currentLanguage = getCurrentLanguage();
        this.optionsversion = getCurrentErrorsVersion();

        const options = getCurrentErrorsOptions();
        this.state = {};
        this.state.options = options.values;
        this.blockTitles = options.titles;

    }

    langsel(fr,en)
    {
        return this.currentLanguage=="fr"?fr:en;
    }

    onCheck = (key, checked) => {
        this.setState(state => ({
            options: state.options.map(option =>
                option.key === key
                    ? { ...option, value: checked }
                    : option
            )
        }));
    };

    renderBlock(blockNumber) {
        const options = this.state.options.filter(
            option => option.bloc === blockNumber
        );

        return (
            <div
                key={blockNumber}
                style={{
                    marginBottom: "12px",
                    border: "1px solid #404040",
                    borderRadius: "6px",
                    background: "rgba(255,255,255,0.03)"
                }}
            >
                <div
                    style={{
                        background: "#2b4b74",
                        color: "#FFFFFF",
                        fontWeight: "bold",
                        fontSize: "12px",
                        padding: "5px 8px",
                        borderTopLeftRadius: "6px",
                        borderTopRightRadius: "6px"
                    }}
                >
                    {this.blockTitles[blockNumber]}
                </div>

                <div
                    style={{
                        padding: "6px"
                    }}
                >
                    {options.map(option => (
                        <label
                            key={option.key}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                color: "#E0E0E0",
                                fontSize: "12px",
                                cursor: "pointer",
                                padding: "2px 0",
                                userSelect: "none"
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={option.value}
                                onChange={e =>
                                    this.onCheck(
                                        option.key,
                                        e.target.checked
                                    )
                                }
                                style={{
                                    marginRight: "8px",
                                    accentColor: "#42A5F5"
                                }}
                            />

                            {option.label}
                        </label>
                    ))}
                </div>
            </div>
        );
    }

    render() {

        setCurrentErrorsOptions(
            {
                version: this.optionsversion,
                values: this.state.options,
                titles: this.blockTitles,
                language: this.currentLanguage,
            }
        )
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden",
                    background: "transparent",
                    boxSizing: "border-box",
                    padding: "6px",

                    scrollbarWidth: "none",
                    msOverflowStyle: "none"
                }}
                className="subtitle-options"
            >
                <style>
                    {`
                        .subtitle-options::-webkit-scrollbar{
                            display:none;
                        }
                    `}
                </style>

                {Object.keys(this.blockTitles).map(block =>
                    this.renderBlock(Number(block))
                )}
            </div>
        );
    }
}

export default SubtitleOptions;